function formIframeCallback(pCode, pFields){
	$(document).trigger('onIframeCallback', [pCode, pFields]);
}

(function () {
    $(document).on('ready', function(){


	    function initInputFocus(){
	        $(document).on('focus', 'input, textarea', function(e){
	            var holder = $(this).attr("placeholder"); var val = $(this).val(); if(val == holder)$(this).val("");
	        });

	        $(document).on('blur', 'input', function(e){
	            var holder = $(this).attr("placeholder"); var val = $(this).val(); if(val == "")$(this).val(holder);
	        });
	    }
	    initInputFocus();


	    $(document).on('onIframeCallback', function(e, pCode, pFields){
	         if(pCode == "error"){
	             $("p.error-msg").fadeIn(250);
	             window.formValidator.displayFormAfterVerifyFields("form", "is-error", pFields.fields, true);
	         }else{
	             $("p.error-msg").hide(); 
	             $(".confirmation").show();
	         }
	     });




	    window.formValidator = {
		    validateRegExp:function(pValue, pType){
		        var reg;
		        switch(pType){
		            case 'mail':
		                    reg  = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		            break;

		            case 'phone':
		                    reg = /!^(\+){0,1}[0-9\/ \-\.]{8,25}$!/;
		            break;

		            default:
		            break;

		        }

		        if(!is_string(pValue))return true;
		        if(!reg)return true;
		        if (pValue.match(reg))return true;
		        return false;
		    },

		    verifyField:function(pValue, pType, pIsRequired){
		        //valeur de code => ok, required, invalid, existing
		        var code = "ok";

		        if(pValue == ""){
		            if(pIsRequired){
		                code = "required";
		            }
		        }else{
		            if(pType != ""){
		                if(!this.validateRegExp(pValue, pType)){
		                    code = "invalid";
		                }
		            }
		        }
		        return code;
		    },

		    verifyAllFieldsForm:function(pFields){

		        var retour = {};
		        var hasError = false;
		        var msg = "";
		        
		        for(var field in pFields) { 
		            var code = this.verifyField(pFields[field].value, pFields[field].type, pFields[field].required);
		            if(code != "ok")hasError = true;
		            retour[field] = {code:code, value:pFields[field].value};
		        }
		        return {fields:retour, hasError:hasError, msg:msg}; 
		    },
		    
		    
		    displayFormAfterVerifyFields:function(pSelecorJquery, pClassNameErrorField, pVerifyFields, pDisplayErrorForLabel){
		        //pVerifyFields correspond au tableau de retour de la methode FORM_MANAGER.verifyField(pFields) :

		        for(var field in pVerifyFields) { 
		            this.displayFormElementByCode(pVerifyFields[field].code, pSelecorJquery + " #" + field, pClassNameErrorField);
		            if(pDisplayErrorForLabel == true)this.displayFormElementByCode(pVerifyFields[field].code, pSelecorJquery + " label[for=" + field+"]", pClassNameErrorField);
		        }
		    },

		    displayFormAllFieldsNoError:function(pSelecorJquery, pClassNameErrorField, pVerifyFields, pDisplayErrorForLabel){
		        for(var field in pVerifyFields) { 
		            $(pSelecorJquery + " #" + field).removeClass(pClassNameErrorField);
		            if(pDisplayErrorForLabel == true)$( pSelecorJquery + " label[for=" + field+"]").removeClass(pClassNameErrorField);
		        }
		    },

		    displayFormElementByCode:function(pCode, pSelecorJquery, pClassNameErrorField){
		        if(pCode == "ok"){
		            $(pSelecorJquery).removeClass(pClassNameErrorField);
		        }else{
		            $(pSelecorJquery).addClass(pClassNameErrorField);
		        }
		    } 

		};

    });

})();




(function () {
    $(document).on('ready', function(){

        /*** transitions FancyBox resizeIn ****/
        (function(f,b){b.transitions.resizeIn=function(){var c=b.previous,a=b.current,d=c.wrap.stop(!0).position(),e=f.extend({opacity:1},a.pos);d.width=c.wrap.width();d.height=c.wrap.height();c.wrap.stop(!0).trigger("onReset").remove();delete e.position;a.inner.hide();a.wrap.css(d).animate(e,{duration:a.nextSpeed,easing:a.nextEasing,step:b.transitions.step,complete:function(){b._afterZoomIn();a.inner.fadeIn("fast")}})}})(jQuery,jQuery.fancybox);


        if(window.FastClick)window.FastClick.attach(document.body);

        $('.fancybox').fancybox({
            padding : 0, margin:0,
            openEffect : 'fade',
            closeEffect : 'fade',
            nextMethod : 'resizeIn',
            prevEffect : 'resizeIn',
            nextSpeed  : 200,
            prevSpeed  : 200,
            helpers:  {
                overlay: { locked: false },
                title : {type : 'over'}
            }
        });

        function isOnScreen ($elt, cbTrue, cbFalse, viewport) {
            var bounds = $elt.offset();
            bounds.right = bounds.left + $elt.outerWidth();
            bounds.bottom = bounds.top + $elt.outerHeight();
            bounds.bottom -= 100;

            var isOnScreen = (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

            return isOnScreen ? cbTrue && cbTrue(viewport, bounds) : cbFalse && cbFalse(viewport, bounds);
        };



        function checkInViewportElements(){
            var win = $(window);

            var viewport = {
                top : win.scrollTop(),
                left : win.scrollLeft()
            };
            viewport.right = viewport.left + win.width();
            viewport.bottom = viewport.top + win.height();

            $('.viewport-wait').each(function(){
                var $e = $(this);

                isOnScreen($e, function(){
                    $e.addClass('is-in-viewport');
                }, function(){
                    $e.removeClass('is-in-viewport');
                }, viewport);
            }) ;
        }



        //FIXED MENU
        var oldScrollValue = 0;
        var checkMenuMode = function (e) {
            var offset = 140;
            var scroll = $(document).scrollTop();

            if (!$('body').hasClass('is-menu-open')) {
                if ((scroll > oldScrollValue) && (scroll > offset + 50)) {
                    if (!$('body').hasClass('is-menu-todown')) $('body').addClass('is-menu-todown');
                } else {
                    if ($('body').hasClass('is-menu-todown')) $('body').removeClass('is-menu-todown');
                }
            } else {
                $('body').removeClass('is-menu-todown');
            }

            oldScrollValue = scroll;
        };


        $(window).on('scroll resize', function(){
            checkInViewportElements();
            checkMenuMode();
        });
        $(window).trigger('resize');

        $(document).on('click', '#menu-icon', function(e){
            $('body').toggleClass('is-nav-top-open');
            oldScrollValue = 0;
            $(window).trigger('resize');
        });


        $('[data-parallax]').parallax();


        $(document).on('focus', 'input, textarea', function(e){
            $(this).parents('.form-group').addClass('is-focus');
        });
        $(document).on('blur check', 'input, textarea', function(e){
            if($(this).val() == ''){
                $(this).parents('.form-group').removeClass('is-focus');
            }else{
                $(this).parents('.form-group').addClass('is-focus');
            }
        });
        $('input, textarea').trigger('check');




        if($('.socials-slider').length > 0){
            $('.socials-slider').slick({
                autoplay : false,
                autoplaySpeed : 7000,
                arrows : true,
                infinite: true,
                dots: true,
                speed : 1000,
                prevArrow : '<button type="button" class="slick-prev"><span class="u-visually-hidden">Prev</span></button>',
                nextArrow : '<button type="button" class="slick-next"><span class="u-visually-hidden">Next</span></button>',
                adaptiveHeight: true,
                slidesToShow : 4,
                slidesToScroll : 4,
                cssEase : 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                responsive: [
                    {
                        breakpoint: 1480,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 1070,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false
                        }
                    }
                ]
            });
        }


        if($('.blog__slider').length > 0){
            $('.blog__slider-pictures').slick({
                autoplay : true,
                autoplaySpeed : 4000,
                arrows : false,
                infinite: true,
                dots: false,
                draggable: false,
                pauseOnFocus: false,
                pauseOnHover: false,
                speed : 1000,
                lazyLoad: 'ondemand',
                slidesToShow : 1,
                fade: true,
                cssEase : 'cubic-bezier(0.645, 0.045, 0.355, 1.000)'
            });
        }







        /*$(document).on('mouseover', '.lieux__item img', function(){
            $(this).parent().addClass('is-active');
        });
        $(document).on('mouseout', '.lieux__item img', function(){
            $(this).parent().removeClass('is-active');
        });


        if($('.home-slider').length > 0){

            $('.home-slider__slider').slick({
                autoplay : true,
                autoplaySpeed : 7000,
                arrows : false,
                speed : 1000,
                cssEase : 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                lazyLoad : 'progressive'
            });
        }*/


    });

})();


//callback Gmaps Async
function initializeGmaps(){
    $(window).trigger('gmapLoaded');
}

//# sourceMappingURL=bundle.js.map